import Chart from 'chart.js';

export default {
  data() {
    return {
      data: {
        labels: '',
        datasets: [{
          label: '',
          data: ''
        }],
        options: this.chartData.options,
      },
      chartType: this.chartData.chartType,
      colors: [
        '#41B883', '#E46651', '#00D8FF', '#DD1B16', '#ff9234', '#d1f6c1', '#951555', '#f7de1c',
        '#8F4941', '#9E5A76', '#837CA6', '#459FB7', '#34BA9E', '#88CB6E', '#E7CD52', '#00adb5',
        '#C05556', '#AA5E87', '#70749F', '#308191', '#34846B', '#617F47', '#88753B', '#A06A4C',
        '#071e3d', '#1f4287', '#278ea5', '#21e6c1', '#f9ad8d', '#929aab', '#db2d43', '#A06A4C',
        '#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#1f77b4', '#ff7f0e', '#2ca02c', '#d62728',
        '#1C4670', '#278AB0', '#EAEAE0', '#E32227', '#686361', '#0070E0', '#FFCE75', '#0080F6',
        '#8F4941', '#9E5A76', '#837CA6', '#459FB7', '#34BA9E', '#88CB6E', '#E7CD52', '#00adb5',
        '#C05556', '#AA5E87', '#70749F', '#308191', '#34846B', '#617F47', '#88753B', '#A06A4C',
        '#071e3d', '#1f4287', '#278ea5', '#21e6c1', '#f9ad8d', '#929aab', '#db2d43', '#A06A4C',
        '#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#1f77b4', '#ff7f0e', '#2ca02c', '#d62728',
        '#1C4670', '#278AB0', '#EAEAE0', '#E32227', '#686361', '#0070E0', '#FFCE75', '#0080F6',
        '#071e3d', '#1f4287', '#278ea5', '#21e6c1', '#f9ad8d', '#929aab', '#db2d43', '#A06A4C',
        '#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#1f77b4', '#ff7f0e', '#2ca02c', '#d62728',
      ],
      _chart: null,
      _plugins: this.plugins
    };
  },
  render: function (createElement) {
    return createElement(
      'div', {
        style: this.styles,
        class: this.cssClasses
      },
      [
        createElement(
          'canvas', {
            attrs: {
              id: this.chartData.selector,
              height: this.chartData.height
            },
            ref: 'canvas'
          }
        )
      ]
    )
  },
  props: {
    chartData: {
      type: Object
    },
    width: {
      default: 400,
      type: Number
    },
    height: {
      default: 400,
      type: Number
    },
    cssClasses: {
      type: String,
      default: ''
    },
    styles: {
      type: Object
    },
    plugins: {
      type: Array,
      default() {
        return []
      }
    }
  },
  beforeDestroy() {
    if (this.$data._chart) {
      this.$data._chart.destroy()
    }
  },
  computed: {
    /**
     * Dataset getter function
     * @memberOf Chart
     * @returns {Object} normalized dataset
     */
    ds() {
      return this.chartData.data.map((d) => {
        let labels = this.chartData.dim ? d[this.chartData.dim] : d;
        let datasets = this.chartData.metric ? d[this.chartData.metric] : d;
        return {labels: labels, datasets: datasets};
      });
    },
    getLabel() {
      return this.chartData.data.map((d) => {
        return this.chartData.dim ? d[this.chartData.dim] : d;
      });
    },
    getDataset() {
      return this.chartData.data.map((d) => {
        return this.chartData.metric ? parseInt(d[this.chartData.metric]) : parseInt(d);
      });
    },
    getBackground() {
      if (this.chartData.chartType === 'pie') {
        return this.colors;
      } else {
        return this.colors[Math.floor(Math.random() * this.colors.length)];
      }
    }
  },
  methods: {
    exportChart() {
      return new Promise(async resolve => {
        let chartUrl = this.$data._chart.toBase64Image();
        await require("downloadjs")(chartUrl, "chart.png", "image/png");
        resolve();
      });
    },
    getDatasetMixed(field) {
      return this.chartData.data.map((d) => {
        let datasets = field ? parseInt(d[field]) : parseInt(d);
        return datasets;
      });
    },
    graph() {
      this.data.datasets = [];
      this.chartType = (this.chartData.chartType === 'mixed') ? this.chartData.metricMixed[0].type : this.chartData.chartType;

      this.chartData.options.title.text = this.chartData.title;
      this.data.labels = this.getLabel;

      if (this.chartData.chartType === 'mixed') {
        this.setStackedBar(false);
        for (let i = 0; i < this.chartData.metricMixed.length; i++) {
          let metric = this.chartData.metricMixed[i];
          let dataset = {
            label: metric.field,
            fill: false,
            backgroundColor: this.colors[i],
            data: this.getDatasetMixed(metric.field),
            type: metric.type
          };
          this.data.datasets.push(dataset);
        }
      } else if ((this.chartData.chartType === 'bar' || this.chartData.chartType === 'vbar') && this.chartData.stackedBar) {
        this.setStackedBar(true);
        let dataset = {
          label: this.chartData.metric,
          fill: false,
          backgroundColor: this.getBackground,
          data: this.getDataset,
          type: this.chartData.chartType
        };
        this.data.datasets.push(dataset);

        for (let i = 0; i < this.chartData.metricStacked.length; i++) {
          let metric = this.chartData.metricStacked[i];
          let dataset = {
            label: metric.field,
            fill: false,
            backgroundColor: this.colors[i],
            data: this.getDatasetMixed(metric.field),
            type: this.chartData.chartType
          };
          this.data.datasets.push(dataset);
        }
      } else {
        this.setStackedBar(false);
        this.data.datasets = [
          {
            label: this.chartData.metric,
            fill: false,
            backgroundColor: this.getBackground,
            data: this.getDataset,
            type: this.chartData.chartType,
          }
        ];

      }

      for (let i = 0; i < this.data.datasets.length; i++) {
        if (this.data.datasets[i].type === "area") {
          this.data.datasets[i].type = 'line';
          this.data.datasets[i].fill = true;
          this.chartType = 'line';
        } else if (this.data.datasets[i].type === "scatter") {
          this.data.datasets[i].type = 'line';
          this.data.datasets[i].showLine = false;
          this.chartType = 'line';
        } else if (this.data.datasets[i].type === "vbar") {
          this.data.datasets[i].type = 'bar';
          this.chartType = 'bar';
        } else if (this.data.datasets[i].type === "bar") {
          this.data.datasets[i].type = 'horizontalBar';
          this.chartType = 'horizontalBar';
        }
      }

      this.renderChart({
        labels: this.getLabel,
        datasets: this.data.datasets
      }, this.chartData.options);
    },
    addPlugin(plugin) {
      this.$data._plugins.push(plugin)
    },
    generateLegend() {
      if (this.$data._chart) {
        return this.$data._chart.generateLegend()
      }
    },
    renderChart(data, options) {
      if (this.$data._chart) this.$data._chart.destroy();
      this.$data._chart = new Chart(
        this.$refs.canvas.getContext('2d'), {
          type: this.chartType,
          data: data,
          options: options,
          plugins: this.$data._plugins
        }
      )
    },
    setStackedBar(val) {
      let optionAxes = {
        stacked: false,
        ticks: {
          beginAtZero: true
        }
      };
      this.chartData.options.scales.xAxes[0] = optionAxes;
      this.chartData.options.scales.yAxes[0] = optionAxes;
      if (val) {
        optionAxes.stacked = true;
      } else {
        if (this.chartData.chartType === 'pie') {
          this.chartData.options.scales.xAxes.splice(0, 1);
          this.chartData.options.scales.yAxes.splice(0, 1);
        }
      }
    }
  },
};
